//Константы для отображения графа
export default {
  load:{
    data: "Загрузка данных ...",
    generateVisual: "Генерация визуализации ...",
    faledLoadOntology: "Не удалось загрузить онтологию",
    okLoadOntology: "Онтология загружена успешно",
    warnLoadOntology: "Онтология загружена с предупреждениями",
    detail: "Детализация"
  },
  statistic : {
    classes: "Классов",
    subclasses: "ПодКлассы",
    types: "Типы",
    objectProperties: "Объектные свойства",
    dataProperties: "Свойства с данными",
    individuals: "Индивидуалов",
    nodeCount: "Вершин",
    nodeOf: "из",
    nodeDetails: "из них",
    edgeCount: "Рёбер",
    edgeOf: "из",
    edgeDetails: "из них",
    nodeIncluding: "включая",
    equivalents: "эквивалентов",
    external: "внешних",
    externalElement: "внешних элементов"
  },
  detail: {
    noSelect: "Выберите элемент в графе",
    lable: "Метка",
    type: "Тип",
    dataType: "Тип данных",
    characteristics: "Характеристики",
    version: "Версия",
    authors: "Автор(ы)",
    language: "Язык"
  },
  options: {
    title: "Опции графа" 
  },
  modes: {
    title: "Режимы" 
  },
  search: {
    placeholder: "Поиск",
    noFind: "Ничего не найдено, введите поисковый запрос.",
  },
  legend: {
    title: "Легенда",
    detail: "Детальная информация об используемых графических примитивах приведена в статье",
    noLegend: "Узлы графа отображают субъекты и объекты триплетов, рёбры - предикаты."
  },
  ontology: {
    title: "Ontology",
    dcTitle: "Наименование",
    dcTitleHint: "Наименование онтологии из dc:title",
    version: "Версия",
    versionHint: "Номер версии онтологии из owl:versionInfo",
    creator: "Авторы",
    creatorHint: "Авторы онтологии из dc:creator"
  },
  description: {
    title: "Описание",
  },
  prefix: {
    title: "Префикс"
  },
  metadata: {
    title: "Метаданные"
  },
  sidebar: {
    noTitle: "Название не доступно",
    noDescription: "Описание не доступно",
    notGiven: "нет",
    noAnnatations: "Нет доступных аннотаций"
  },
  warning: {
    filterHint: "Активирован сворачивающий фильтр.<br>" +
      "Количество отображаемых элементов было автоматически уменьшено.<br>" +
      "Используйте ползунок сворачивания и/или чекбокс в <em>Фильтр</em> чтобы настроить визуализацию.<br><br>"+
      "<em>Примечание:</em> Может наблюдаться снижение производительности при увеличении количества визуальных элементов на экране."
  },
  loading_data: "Загрузка данных для графа...",
  section_statistic: "Статистика",
  section_details: "Детализация по элементу",
  section_legend: "Легенда",
  process: {    
	  START:  "Загрузка данных для графа...",
	  START_CONTENT:  "Получение данных из хранилища...", //1000;
	  CONTENT_RECEIVED: "Содержимое (исходные данные графа) получены...", // 1001;
	  START_CACHE: "Поиск визуальной схемы графа в кэше ...", //1002;
	  FINISH_CACHE: "Визуальная схема графа в кэше найдена...", //1003;	
	  CONVERT_PREPARE: "Подготовка данных для конвертации в визуальную схему...", // 1010;
	  CONVERT: "Конвертация данных в визуальную схему графа...", // 1011;
	  ERROR: "Ошибка при конвертации!", // 1013;
	  FINISH:  "Данные получены. Начата подготовка к отображению графа..."
  },
  filter: {
    title: "Фильтр",
    topic: "Фильтры",
    edges: "Связи",
    allLink: "Все связи",
    hideLinks: "Исключить связи"
  }
};